import { render } from "./MiniCalendarWidget.vue?vue&type=template&id=5f50c66a"
import script from "./MiniCalendarWidget.vue?vue&type=script&lang=js"
export * from "./MiniCalendarWidget.vue?vue&type=script&lang=js"

import "./MiniCalendarWidget.vue?vue&type=style&index=0&id=5f50c66a&lang=css"

import exportComponent from "/opt/approot/build.20261030-093834-708061d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__